/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { mapModifiers } from 'libs/component';
import { FormProvider, useForm } from 'react-hook-form';
import { ContactInfoItem } from 'components/molecules/contact-info-item';
import { TextField } from 'components/atoms/text-field';
import { EMAIL_REGEXP } from 'libs/constants';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'react-i18next';

export interface ContactFormProps {
  onSubmit?: (data: any) => void;
}

export const ContactForm: React.FC<ContactFormProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const methods = useForm();
  const {
    formState: { errors },
  } = methods;

  const hasError = Object.keys(errors).length > 0;

  return (
    <div className={mapModifiers('o-contact-form', hasError && 'error')}>
      <div className="o-contact-form__info">
        <ContactInfoItem
          icon="documents"
          title={t('contact.enquiry.title')}
          tit="（中国办公室销售及媒体总负责人：管震）"
          tel="(8610)65911278-8827"
          phone="+86 13911884201"
          email="jenny.guan@ctvgb.com.cn"
          tit2="（中国办公室媒体高级经理：王博涵）"
          tel2="010-65910981-8012"
          email2="hedy.wang@ctvgb.com.cn"
          description={t('contact.enquiry.description')}
        />

      </div>
      <div className="o-contact-form__form-holder">
        <FormProvider {...methods}>
          <form className="o-contact-form__form" onSubmit={methods.handleSubmit(onSubmit as any)} noValidate={true}>
            <div className="o-contact-form__form-content">
              <div className="o-contact-form__form-block">
                <div className="o-contact-form__form-item">
                  <TextField
                    type="text"
                    placeholder={t('contact.enquiry.form.name')}
                    label={t('contact.enquiry.form.name')}
                    error={errors}
                    formKey="name"
                    validationRules={{
                      required: true,
                    }}
                  />
                </div>
                <div className="o-contact-form__form-item">
                  <TextField
                    type="tel"
                    placeholder={t('contact.enquiry.form.phone')}
                    label={t('contact.enquiry.form.phone')}
                    error={errors}
                    formKey="phone_number"
                    validationRules={{
                      required: true,
                    }}
                  />
                </div>
              </div>
              <div className="o-contact-form__form-block">
                <div className="o-contact-form__form-item">
                  <TextField
                    type="email"
                    placeholder={t('contact.enquiry.form.email')}
                    label={t('contact.enquiry.form.email')}
                    error={errors}
                    formKey="email"
                    validationRules={{
                      required: true,
                      pattern: {
                        value: EMAIL_REGEXP,
                        message: t('form-error.email'),
                      },
                    }}
                  />
                </div>
                <div className="o-contact-form__form-item">
                  <TextField
                    type="text"
                    placeholder={t('contact.enquiry.form.topic')}
                    label={t('contact.enquiry.form.topic')}
                    error={errors}
                    formKey="topic"
                    validationRules={{
                      required: t('form-error.require'),
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-contact-form__form-action">
              <Button type="submit" size="large">
                {t('contact.enquiry.form.send')}
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
      {/* 活动二维码 */}
      <div className='o-contact-QR'>
        <div className="o-contact-QR_code">
          <img src="/images/qsncc_erweima.png" alt="thank you" width="140" height="140" />
        </div>
        <p className="o-contact-QR__content-title">{t('contact.advertising.title')}</p>
        <p
          className="o-contact-QR__content-description"
          dangerouslySetInnerHTML={{ __html: t('contact.advertising.description') }}
        />
        <p
          className="o-contact-QR__content-description"
          dangerouslySetInnerHTML={{ __html: t('contact.advertising.time') }}
        />
      </div>
    </div>
  );
};
